import { render, staticRenderFns } from "./InputPlate.vue?vue&type=template&id=65261e8e&scoped=true&"
import script from "./InputPlate.vue?vue&type=script&lang=js&"
export * from "./InputPlate.vue?vue&type=script&lang=js&"
import style0 from "./InputPlate.vue?vue&type=style&index=0&id=65261e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65261e8e",
  null
  
)

export default component.exports